import { AuthBackground } from './features/Auth/components/AuthBackground';
import { AuthContainerCard } from './features/Auth/components/AuthContainerCard';
import { AuthFooter } from './features/Auth/components/AuthFooter';
import { AuthInputCard } from './features/Auth/components/AuthInputCard';
import { AuthLogo } from './features/Auth/components/AuthLogo';


const SUPPORT_EMAIL = 'team@qura.law';
const QURA_2_0_URL = 'https://qura-2.0.qura.law';

export const Deactivated = () => {
  return (
    <AuthBackground>
      <AuthContainerCard>
        <AuthInputCard>
          <div className="h-10" />
          <AuthLogo />
          <div className="flex flex-col items-center space-y-8 px-8 mt-2">
            <h1 className="text-2xl font-medium tracking-tight text-gray-900">
              Important Update
            </h1>
            
            <div className="max-w-2xl mx-auto">
              <p className="text-base text-gray-500 leading-relaxed text-center">
              We’re excited to announce <a href={QURA_2_0_URL} className="text-blue-600 hover:text-blue-800 underline">Qura 2.0</a>, packed with powerful new features, including extensive authority data, lower instance courts, doctrine, and document relations.              </p>
            </div>

            <div className="w-full max-w-lg mx-auto bg-qura-neutral-silver bg-opacity-50 rounded-lg p-6">
              <div className="space-y-4">
                <div className="flex items-center justify-center">
                  <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-normal text-gray-600 bg-yellow-100 border border-yellow-200 border-opacity-50 bg-opacity-50">
                    Qura 1.0 is no longer available
                  </span>
                </div>
                
                <p className="text-sm text-gray-500 text-center">
                  Please create your new Qura 2.0 account through the link provided to you by email. If you haven't received your registration link, <a href={`mailto:${SUPPORT_EMAIL}`} className="text-blue-600 hover:text-blue-500 transition-colors">contact Qura directly</a> or your internal administrator, and we'll quickly provide it.
                </p>

                <a href={QURA_2_0_URL} className="block w-full text-center px-4 py-2 bg-gray-900 text-white text-sm rounded-md hover:bg-gray-800 transition-colors">
                  Continue to Qura 2.0
                </a>
              </div>
            </div>
          </div>
          <div className="h-16" />
        </AuthInputCard>
      </AuthContainerCard>
      <AuthFooter />
    </AuthBackground>
  );
};
